<template>
    <div class="core">
         <div class="layui-fluid">
            <pub-search
              :search-type="'add'"
              :tableObj="tableObj"
              :searchConfig="searchConfig"
              exportTemplate="评价表.xlsx"
            >
              <template>
                  <layui-exportexcel template-name = "评价表.xlsx" ref="export">
                      <template slot-scope="{scope}">
                          <button class="layui-btn layuiadmin-btn-role" @click="scope.export(tableObj)"><i class="layui-icon">&#xe67d;</i>导出</button>
                      </template>
                  </layui-exportexcel>
              </template>
            </pub-search>
            <template>
              <layui-table
                ref="appraise"
                table-name="YW_SERVICE_ORDER_V1"
                :page-size="20"
                :page-range="6"
                :page-options="[10, 20, 50, 100]"
                :skin="'line'"
                :defaultCondition="{'SERVICE_STATE:0': '7', 'SERVICE_DELETED:10': '1'}"
                @table-event-detail="detail($event)"
                @table-event-appraise="appraise($event)"
              >
                <div>
                    <div checkbox="true" align="center" fixed="left" width="60"></div>
                    <layui-tableconfig :config = "tableList"></layui-tableconfig>
                    <div rowspan="3" align="center" fixed="right" title="操作" width="130">
                        <script type="text/html" v-pre>
                             <a class="layui-btn-xs" lay-event="detail" title='查看'>查看</a>
                             {{#  if(d._mark.indexOf("appraise_pj") > -1){ }}
                             <a class="layui-btn-xs" lay-event="appraise" title='评价'>评价</a>
                             {{#  } }}
                        </script>
                    </div>
                </div>
              </layui-table>
            </template>
        </div>
    </div>
</template>
<script>
import "../../../utils/map/css/core.css"


export default {
  name: 'appraise',
  data () {
    return {
        tableList:[
          { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 150 },
          { field: 'SERVICE_ORDER_NUM', title: '现场服务单编号', width: 150 },
          { field: 'ORDER_STATE_DESC', title: '服务请求单状态', width: 150, sort: true},
          { field: 'SERVICE_STATE_DESC', title: '现场服务单状态', width: 150, sort: true},
          { field: 'WORK_ORDER_CATEGORY_DESC', title: '服务请求单类别', width:130, filter: { 'domain' : 'WORK_ORDER_CATEGORY'}},
          { field: 'CLIENT_NAME', title: '客户' , width: 200},
          { field: 'BRAND_NAME', title: '品牌' , width: 150},
          { field: 'STORE_NAME', title: '门店', width: 150 },
          { field: 'ENGINEER_NAME', title: '工程师', width: 130 },
          { field: 'SERVICE_NAME', title: '服务商', width: 200  },
          { field: 'EVALUATE_ZS_MANAGER_DESC', title: '是否准时', width: 120},
          { field: 'EVALUATE_JS_MANAGER_DESC', title: '技术评价', width: 90 },
          { field: 'EVALUATE_REMARKS_MANAGER', title: '备注' , width: 150},
          { field: 'APPRAISE_PSN_EXT_NAME', title: '评价人', width: 150},
          { field: 'EVALUATE_TIME_MANAGER', title: '评价时间', width: 180},
          { field: 'MANAGER_NAME', title: '项目经理', width: 150},
          { field: 'EVALUATE_ZS_DESC', title: '回复是否准时', width: 150},
          { field: 'EVALUATE_ZQ_DESC', title: '回复是否准确', width: 150},
          { field: 'EVALUATE_TD_DESC', title: '服务态度', width: 120},
          { field: 'EVALUATE_REMARKS', title: '备注', width: 150 },
          { field: 'SERVICE_NAME', title: '被评价人', width: 150},
          { field: 'EVALUATE_TIME', title: '评价时间', width: 180},
        ],
        formData: {},
        tableObj: {
          checkedRows: 0,
          queryObject: {}
        },
        searchConfig: {
          basic: [
            {
              TYPE: 'input',
              WIDTH: 260,
              FIELD:
                'WORK_ORDER_NUM:2,SERVICE_ORDER_NUM:2,CLIENT_NAME:2,BRAND_NAME:2,STORE_NAME:2,ENGINEER_NAME:2,SERVICE_NAME:2,MANAGER_NAME:2',
              PLACEHOLDER: '请输入查询条件'
            }
          ],
          advanced: [
            { TYPE:'input', NAME: '现场服务单编号 :', FIELD:'SERVICE_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '服务请求单编号 :', FIELD:'WORK_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '客户 :', FIELD:'CLIENT_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '品牌 :', FIELD:'BRAND_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '门店 :', FIELD:'STORE_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '工程师 :', FIELD:'ENGINEER_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '服务商 :', FIELD:'SERVICE_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '项目经理 :', FIELD:'MANAGER_NAME:2', PLACEHOLDER: '请输入查询条件'},
            {
              TYPE: 'layui-multiselect',
              NAME: '是否准时:',
              FIELD: 'EVALUATE_ZS:1',
              textField: 'text',
              valueField: 'value',
              initData: this.dict.getData('EVALUATE_ZS')
            },
          ]
        }
    }
  },
  mounted(){
    this.tableObj = this.$refs.appraise;
  },
  methods: {
    detail(params){
      var componentName = 'detailForm-' + params.data["SERVICE_ORDER_NUM"];
      this.baseComponent.smartLoadComponent('appraiseForm', {title: '详情-' + params.data['SERVICE_ORDER_NUM'], source: 'workOrder', formData: params.data}, {uniqueName: componentName});
    },
    appraise(params){
      var componentName = 'appraiseForm-' + params.data["SERVICE_ORDER_NUM"];
      this.baseComponent.smartLoadComponent('appraiseForm', {title: '评价-' + params.data['SERVICE_ORDER_NUM'], source: 'workOrder', formData: params.data, operateType: 'pj', tableObj: this.tableObj}, {uniqueName: componentName});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/workOrder/apprais/index.vue